import { Flex, ViewChartDetailsRow } from "components/atoms";
import LoadingSpinner from "components/atoms/LoadingSpinner/LoadingSpinner";
import { DTOStartupDetailsViewDataset } from "components/types";
import React from "react";
interface IViewChartWidgetProps {
  dataset?: DTOStartupDetailsViewDataset[];
  wrapperClass: string;
  isLoading: boolean;
}
export const ViewChartWidget = ({
  dataset,
  wrapperClass,
  isLoading,
}: IViewChartWidgetProps) => {
  return (
    <Flex
      className={wrapperClass}
      flex={1}
      alignSelf="stretch"
      minWidth={"200px"}
      maxHeight={"200px"}
      flexDirection={"column"}
      paddingLeft={"1rem"}
      paddingRight={"1rem"}
    >
      <Flex width={"100%"}>
        <h6 className="tx-primary">Views per department</h6>
      </Flex>
      <Flex
        flex={1}
        width={"100%"}
        flexDirection={"column"}
        height={"100%"}
        justifyContent={"space-around"}
        alignItems={isLoading?'center':undefined}
      >
        {isLoading ? (
          <LoadingSpinner dimension="40px" />
        ) : (
          dataset?.map((el) => <ViewChartDetailsRow {...el} key={el.label} />)
        )}
      </Flex>
    </Flex>
  );
};
